export const DEFAULT_FILTERS = {
  category: [],
  location: [],
  type: '',
};

export const eventTypeOptions = [
  {
    value: 'Présentiel',
    label: 'Présentiel'
  },
  {
    value: 'Webinaire',
    label: 'Webinaire'
  },
];

export const eventCategories = [
  {
    value: 'Evènements de réseatuge',
    label: 'Evènements de réseautage'
  },
  {
    value: 'Evènements experts',
    label: 'Evènements experts'
  },
  {
    value: 'Rencontres thématiques',
    label: 'Rencontres thématiques'
  },
  {
    value: 'Conventions d\'affaires',
    label: 'Conventions d\'affaires'
  },
  {
    value: 'Evènements partenaires',
    label: 'Evènements partenaires'
  },
];

export const locations = [
  {
    value: 'Région Occitanie Est',
    label: 'Région Occitanie (Est)'
  },
  {
    value: 'Région Occitanie Ouest',
    label: 'Région Occitanie (Ouest)'
  },
    {
    value: 'Région Sud Est',
    label: 'Région Sud (Est)'
  },
  {
    value: 'Région Sud Ouest',
    label: 'Région Sud (Ouest)'
  },
  {
    value: 'Autres France',
    label: 'Autres France'
  },
  {
    value: 'Autres Monde',
    label: 'Autres Monde'
  },
];